import { Component, Inject, OnInit } from '@angular/core';
import { BaseCustomDialog } from '../base-custom-dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ACTION_DATA_SERVICE, ActionDataService } from '../../../../services/action/data.service';
import { ActionIconHelper } from '../../../../helper/action-icon.helper';

@Component({
  selector: 'fi-send-external-email',
  templateUrl: './send-external-email-popup.component.html',
  styleUrls: ['./send-external-email-popup.component.scss'],
  standalone: false,
})
export class SendExternalEmailPopupComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  searchedText = '';
  title: string;
  externalEmail: string;
  iconUrl = ActionIconHelper.getActionIconUrl('LEAD_REMINDER_EXT', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('LEAD_REMINDER_EXT', true);
  submitting: boolean;
  inValidNote = false;

  constructor(
      public dialogRef: MatDialogRef<SendExternalEmailPopupComponent>,
      @Inject(MAT_DIALOG_DATA) public dialogData: { externalEmail: string, contactName: string, leadId: number, leadTypeId: number, title: string },
      @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService
  ) {
    super(dialogRef);

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;
    this.externalEmail = dialogData?.externalEmail;
  }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  submit(): void {
    this.submitting = true;

    this.actionDataService.sendExternalEmail(this.leadId, this.externalEmail).subscribe(({success, data}) => {
      if (success) {
        this.clearClassAndCloseDialog(this.dialogRef, 'remove');
      }

      this.submitting = false;
    });
  }
}
